import { createI18n } from 'vue-i18n'
import enUS from './locales/en-US.js'
import pt from './locales/pt.js'

// Função para detectar idioma preferido
const getInitialLocale = () => {
  // Verificar localStorage primeiro
  const savedLocale = localStorage.getItem('user-locale')
  if (savedLocale) {
    return savedLocale === 'en' ? 'en-US' : 'pt'
  }
  
  // Usar idioma padrão (inglês)
  return 'en-US'
}

const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'en-US',
  messages: {
    'en-US': enUS,
    'pt': pt
  }
})

export default i18n 